<template>
    <section class="py-16">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-6 items-end mb-12">
                <div class="col-span-5">
                    <h2 class="text-5xl leading-tight text-dim_dark">
                        Почувствуй  <br>уникальность в <br> каждой детали
                    </h2>
                </div>
                <div class="col-span-7">
                    <p class="text-lg text-dim_dark">
                        Натяжные потолки, которые мы предлагаем, позволяют <br> реализовать самые интересные и сложные решения. <br> 
                        Они превосходят любой гипсокартон и позволяют создавать <br> неповторимый дизайн помещения.
                    </p>
                </div>
            </div>

            <div class="">
                <swiper
                    :modules="modules"
                    :slides-per-view="3"
                    :space-between="24"
                    :pagination="{ clickable: true }"
                    class="mySwiper"
                >
                    <swiper-slide v-for="(item, index) in 6" :key="index">
                        <WorkCard />
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'
import WorkCard from '@/components/ui/WorkCard.vue'

export default {
    components:{
        WorkCard,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            modules: [Pagination]
        }
    }

}
</script>